import ActivityCategorymasterInput from "../../../components/ActivityMasterInput/ActivityCategorymasterInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import VenueMasterInput from "../../../components/VenueMasterInput/VenueMasterInput";
import Layout from "../../../Layout";

const CreateVenueMaster = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Venues",
      route: "/shore/mobile-masters/venue",
    },
    {
      title: "Add Venue",
      route: "/shore/mobile-masters/venue/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Venues"}>
      <CustomHeaderTitle title={"Create Venue"} />
      <HeaderBread navigation={navigation} title={"Add Venue"}></HeaderBread>
      <VenueMasterInput crisisdata={{}} />
    </Layout>
  );
};

export default CreateVenueMaster;
